import { Translate } from '../translations';
import type { errorHandler } from '@wix/essentials';
import type { updateDataExtensionSchema } from '@wix/bex-utils/@wix/ambassador-data-extensions-v1-data-extension-schema/http';

export const updateDataExtensionSchemaErrors = ({
  translate: t,
}: {
  translate: Translate;
}): errorHandler.ErrorCodesMap<typeof updateDataExtensionSchema> => {
  return {
    INVALID_NAMESPACE: () => ({
      message: t(
        'cairo.customFields.updateDataExtension.invalid-namespace.error',
      ),
      action: {
        text: t('cairo.error.contactSupport.cta'),
        onClick: () => {},
      },
    }),
    FQDN_NOT_FOUND: () => ({
      message: t('cairo.customFields.updateDataExtension.fqdn-not-found.error'),
      action: {
        text: t('cairo.error.contactSupport.cta'),
        onClick: () => {},
      },
    }),
    FQDN_NOT_EXTENSIBLE: () => ({
      message: t(
        'cairo.customFields.updateDataExtension.fqdn-not-extensible.error',
      ),
    }),
    REMOVING_FIELDS_IS_DISALLOWED: () => ({
      message: t(
        'cairo.customFields.updateDataExtension.removing-fields-not-allowed.error',
      ),
    }),
    CHANGING_FIELDS_IS_DISALLOWED: () => ({
      message: t(
        'cairo.customFields.updateDataExtension.changing-fields-not-allowed.error',
      ),
    }),
  };
};
